function copyComments(comments) {
  return comments.map(comment => {
    if(Array.isArray(comment.replies)) {
      return {
        ...comment,
        replies: copyComments(comment.replies)
      };
    }

    return comment;
  });
}

export function replyComment(comments, parentId, newComment) {
  return comments.map(comment => {
    if(comment.id === parentId) {
      return {
        ...comment,
        replies: [newComment, ...(comment.replies ? copyComments(comment.replies) : [])]
      };
    }

    if(comment.replies) {
      return {
        ...comment,
        replies: replyComment(comment.replies, parentId, newComment)
      };
    }

    return comment;
  });
}

export function removeComment(comments, commentId) {
  const newComments = [...comments];
  const commentIndex = newComments.findIndex(comment => comment.id === commentId);

  if(commentIndex === -1) {
    return newComments.map(comment => {
      if(comment.replies) {
        return {
          ...comment,
          replies: removeComment(comment.replies, commentId)
        };
      }

      return comment;
    });
  }

  newComments.splice(commentIndex, 1);
  return newComments;
}

export function commentKarma(comments, id, karma) {
  return comments.map(comment => {
    if(comment.id === id) {
      return {
        ...comment,
        karma
      };
    }

    if(comment.replies) {
      return {
        ...comment,
        replies: commentKarma(comment.replies, id, karma)
      };
    }

    return comment;
  });
}
